import { render, staticRenderFns } from "./OrderPhysical.vue?vue&type=template&id=58ec6a49"
import script from "./OrderPhysical.vue?vue&type=script&lang=js"
export * from "./OrderPhysical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports